import { useContext } from 'react';
import PostContext from '../context/PostProvider';

const usePost = () => {
    const context = useContext(PostContext);
    return context;
}

export default usePost;